// extracted by mini-css-extract-plugin
module.exports = {"customDateRange":"style-module__customDateRange___o7S3X"};